import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { ChildrenFilter } from '../children-filter';
import * as SX from './sx';
import type { MixedFilterProps as Props } from './types';

export const MixedFilter = memo(({ className, ...filter }: Props) => {
  return (
    <Box
      className={classnames('MixedFilter', className)}
      display="flex"
      flexDirection="column"
      gap={1}
      sx={SX.root}
    >
      {filter.name && <Typography variant="body4">{filter.name}</Typography>}

      {filter.items?.map((item) => (
        <ChildrenFilter open key={item.field} noTitle {...item} />
      ))}
    </Box>
  );
});

MixedFilter.displayName = 'MixedFilter';
